import React, { useEffect, useState, useCallback, useRef } from "react";
import { Button, Card, Form, Container, Row, Col, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { fetchSimulationCOnly, simulationCUpdated } from "../../Redux/simulationCReduce";
import { useHistory, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

function UpdateSimulationC({ client }) {
    const dispatch = useDispatch();
    const [produitsData, setProduitsData] = useState([]);
    const [tete, setEntitieTete] = React.useState([]);
    const [loader, setLoader] = React.useState(true);
    const [fileName, setFileName] = useState("");
    const navigate = useHistory();
    const location = useParams();
    const id = location.id;
    const [loading, setLoading] = React.useState(false);
    const saveCalled = useRef(false);


    // Charger données existantes
    const getSimulation = useCallback(async () => {
        const res = await dispatch(fetchSimulationCOnly({ id }));
        let data = res.payload.arrayPrixProd.map(item => ({
            id_simulation: item.id_ligne,
            code_pct: item.code_pct,
            code_article: item.code_article,
            produit: item.produit,
            id_grossiste: item.id_grossiste,
            code_client: item.code_client,
            client: item.client,
            quota: item.quota,
            quantite: item.quantite,
            colisage: item.Coefficient_UC,
            prix: item.prix,
        }));
        setProduitsData(data);

        data = res.payload.entete;

        const table = (
            <Table bordered hover style={{ textAlign: "center" }}>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Date1</th>
                        <th>Date2</th>
                        {/* <th>Date3</th> */}
                        <th>Année</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{data.type}</td>
                        <td>{data.date1}</td>
                        <td>{data.date2}</td>
                        {/* <td>{data.date3}</td> */}
                        <td>{data.annee}</td>
                    </tr>
                </tbody>
            </Table>
        );

        setEntitieTete(table);
        setLoader(false)
    }, [dispatch, id]);

    useEffect(() => {
        getSimulation();
    }, [getSimulation]);

    // Exporter vers Excel


// Exporter vers Excel
const exportToExcel = async () => {
  const exportData = produitsData.map(({ prix, colisage, ...rest }) => rest);

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Simulation");

  if (exportData.length === 0) return;

  // Colonnes dynamiques basées sur les clés
  worksheet.columns = Object.keys(exportData[0]).map((key) => ({
    header: key,
    key: key,
    width: 20,
  }));

  // Header style
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.alignment = { horizontal: "center" };

  exportData.forEach((row) => {
    worksheet.addRow(row);
  });

  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `simulation_${id}.xlsx`);
};


    // Importer depuis Excel
const importFromExcel = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();

  reader.onload = async (evt) => {
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(evt.target.result);

    const worksheet = workbook.worksheets[0];
    if (!worksheet) return;

    // Récupérer headers
    const headers = [];
    worksheet.getRow(1).eachCell((cell) => {
      headers.push(String(cell.value).toLowerCase().trim());
    });

    const expectedHeaders = [
      "id_simulation",
      "code_pct",
      "code_article",
      "produit",
      "id_grossiste",
      "code_client",
      "client",
      "quota",
      "quantite",
    ];

    const isValid =
      expectedHeaders.length === headers.length &&
      expectedHeaders.every((h, i) => h === headers[i]);

    if (!isValid) {
      toast.error(
        "❌ Format Excel incorrect. Colonnes attendues : " +
          expectedHeaders.join(", ")
      );
      return;
    }

    // Lire données
    const newRows = [];
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) return; // skip header

      const rowData = {};
      headers.forEach((header, index) => {
        rowData[header] = row.getCell(index + 1).value;
      });

      newRows.push(rowData);
    });

    // Merge avec anciennes données
    const merged = newRows.map((row) => {
      const old = produitsData.find(
        (p) =>
          p.id_simulation === row.id_simulation &&
          p.id_produit === row.id_produit &&
          p.id_grossiste === row.id_grossiste
      );

      return {
        ...old,
        ...row,
      };
    });

    setProduitsData(merged);
  };

  reader.readAsArrayBuffer(file); // IMPORTANT
};


    // Modification manuelle
    const handleChangeQuantite = (index, value) => {
        const newData = [...produitsData];
        newData[index].quantite = parseFloat(value) || 0;
        setProduitsData(newData);
    };


    const listeSimulationC = () => {
        navigate.push(client + "/listSimulationC");
    };
    // Enregistrer en base
    const saveUpdates = async () => {
        if (saveCalled.current) return;
        saveCalled.current = true;
        setLoading(true);
        await dispatch(simulationCUpdated({ id, produits: produitsData, client }));
        toast.success("Mise à jour réussie !");
        setTimeout(() => listeSimulationC(), 1000);
    };


    function listepp() {
        navigate.push(client + "/listSimulationC");
    }

    return (
        <Container>
            <Row>

                <ToastContainer />
                <Col md="12">
                    <Button
                        id="saveBL"
                        className="btn-wd btn-outline mr-1 float-left"
                        type="button"
                        variant="info"
                        onClick={listepp}
                    >
                        <span className="btn-label">
                            <i className="fas fa-list"></i>
                        </span>
                        Retour à la liste
                    </Button>
                </Col></Row>
            <Card>
                <Card.Header>
                    <Card.Title as="h4">Mise à jour Simulation</Card.Title>
                </Card.Header>
                {loader ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : (
                    <Card.Body>
                        <Button variant="success" onClick={exportToExcel}>Exporter Excel</Button>
                        <Row>
                            <Col md="12">
                                <Form.Control type="file" onChange={(e) => {
                                    importFromExcel(e);       // ta fonction
                                    if (e.target.files.length > 0) {
                                        setFileName(e.target.files[0].name); // stocker nom
                                    }
                                }} accept=".xlsx" style={{ display: "inline", width: "100%" }} />

                            </Col>
                        </Row>

                        <Row>
                            <Col md="12">
                                {tete}
                            </Col>
                            <Col md="12">
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th>Code Article</th>
                                            <th>Produit</th>
                                            <th>Code Grossiste</th>
                                            <th>Grossiste</th>
                                            <th>Quota</th>
                                            <th>Quantité (modifiable)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {produitsData.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.code_article}</td>
                                                <td>{row.produit}</td>
                                                <td>{row.code_client}</td>
                                                <td>{row.client}</td>
                                                <td>{row.quota}</td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.quantite}
                                                        onChange={(e) => handleChangeQuantite(i, e.target.value)}
                                                    />

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Enregistrement en cours...
                            </>
                        ) : <Button variant="info" onClick={saveUpdates}> Enregistrer et envoyer</Button>}

                    </Card.Body>
                )}
            </Card>
        </Container>
    );
}

export default UpdateSimulationC;
